export const TARGET_SETUP_OVERVIEW_ENDPOINTS = {
  LIST: "/target-setup/overview",
  ORG_BREAKDOWN: "/target-setup/overview/orgs",
};
